// src/components/LeadsTable/LeadsTable.jsx
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInbox } from "@fortawesome/free-solid-svg-icons";
import styles from "./LeadsTable.module.scss";

const statusClass = (status) => {
  switch (status) {
    case "nuevo":
      return styles.statusNew;
    case "archivado":
      return styles.statusArchived;
    case "atendido":
      return styles.statusAttended;
    default:
      return "";
  }
};

const LeadsTable = ({
  leads,
  formatDate,
  updateLeadStatus,
  sortOrder,
  toggleSortOrder,
  onViewMore,
}) => {
  if (leads.length === 0) {
    return (
      <div className={styles.emptyWrapper}>
        <div className={styles.emptyCard}>
          <FontAwesomeIcon icon={faInbox} className={styles.emptyIcon} />
          <p className={styles.emptyText}>No hay registros para mostrar</p>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.tableWrapper}>
      <table className={styles.table}>
        <thead>
          <tr>
            <th className={styles.tableHeader}>Nombres</th>
            <th className={styles.tableHeader}>Apellidos</th>
            <th className={styles.tableHeader}>Teléfono</th>
            <th className={styles.tableHeader}>Correo</th>
            <th className={styles.tableHeader}>Estado</th>
            <th
              className={`${styles.tableHeader} ${styles.sortHeader}`}
              onClick={toggleSortOrder}
            >
              Creado el {sortOrder === "asc" ? "▲" : "▼"}
            </th>
            <th className={styles.tableHeader}>Ver más</th>
          </tr>
        </thead>
        <tbody>
          {leads.map((lead) => {
            const last = lead.lastname?.toString().trim() ? lead.lastname : "—";
            return (
              <tr key={lead.id}>
                <td className={styles.tableCell}>{lead.name}</td>
                <td className={styles.tableCell}>{last}</td>
                <td className={styles.tableCell}>{lead.phone}</td>
                <td className={styles.tableCell}>{lead.email}</td>
                <td className={styles.tableCell}>
                  <select
                    value={lead.status}
                    onChange={(e) =>
                      updateLeadStatus(lead.id, e.target.value)
                    }
                    className={`${styles.statusDropdown} ${statusClass(
                      lead.status
                    )}`}
                  >
                    <option value="nuevo">Nuevo</option>
                    <option value="atendido">Atendido</option>
                    <option value="archivado">Archivado</option>
                  </select>
                </td>
                <td className={styles.tableCell}>
                  {formatDate(lead.created_at)}
                </td>
                <td className={styles.tableCell}>
                  <button
                    onClick={() => onViewMore(lead)}
                    className={styles.buttonViewMore}
                  >
                    Ver más
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default LeadsTable;
